import { render, staticRenderFns } from "./InfoChangDetail.vue?vue&type=template&id=2584a395&scoped=true&"
import script from "./InfoChangDetail.vue?vue&type=script&lang=js&"
export * from "./InfoChangDetail.vue?vue&type=script&lang=js&"
import style0 from "./InfoChangDetail.vue?vue&type=style&index=0&id=2584a395&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584a395",
  null
  
)

export default component.exports